/**
 * All new structured tables use the UNIT_REFERENCE column type, which is populated from the tenant Unit
 * Dictionary. However to avoid backfilling existing tables we are retaining the UNIT_SELECTOR column type,
 * with the following hard-coded options.
 *
 * NB: While this approach leaves existing tables untouched, it does NOT guarantee that such tables can be
 * submitted successfully if the Unit Dictionary does not contain a model for the selected unit.
 */

export const VALID_CONCENTRATION_UNITS = [
  'None',
  'M',
  'mM',
  'uM',
  'nM',
  'pM',
  'CF',
  'PFU',
  '%',
  'w/w%',
  'v/v%',
  'w/v%',
  'OD',
  'CFU/g',
  'CFU/kg',
  'CFU/bead',
  'cells/cm^2',
  'cells/vial',
  'umol/g',
  'kg/L',
  'kg/mL',
  'kg/uL',
  'kg/nL',
  'kg/pL',
  'g/L',
  'g/mL',
  'g/uL',
  'g/nL',
  'g/pL',
  'mg/L',
  'mg/mL',
  'mg/uL',
  'mg/nL',
  'mg/pL',
  'ug/L',
  'ug/mL',
  'ug/uL',
  'ug/nL',
  'ug/pL',
  'ng/L',
  'ng/mL',
  'ng/uL',
  'ng/nL',
  'ng/pL',
  'pg/L',
  'pg/mL',
  'pg/uL',
  'pg/nL',
  'pg/pL',
  'lb/gal (US)',
  'lb/qt (US)',
  'lb/pt (US)',
  'oz/gal (US)',
  'oz/qt (US)',
  'oz/pt (US)',
  'cells/L',
  'cells/mL',
  'cells/uL',
  'cells/nL',
  'cells/pL',
  '(x10^3) cells/mL',
  '(x10^4) cells/mL',
  '(x10^5) cells/mL',
  '(x10^6) cells/mL',
  '(x10^7) cells/mL',
  '(x10^8) cells/mL',
  '(x10^9) cells/mL',
  'U/L',
  'U/mL',
  'U/uL',
  'U/nL',
  'U/pL',
  'vg/L',
  'vg/mL',
  'vg/uL',
  'vg/nL',
  'vg/pL',
  'PFU/L',
  'PFU/mL',
  'PFU/uL',
  'PFU/nL',
  'PFU/pL',
  'CFU/L',
  'CFU/mL',
  'CFU/uL',
  'CFU/nL',
  'CFU/pL',
  'TCID50/L',
  'TCID50/mL',
  'TCID50/uL',
  'TCID50/nL',
  'TCID50/pL',
  'TU/L',
  'TU/mL',
  'TU/uL',
  'TU/nL',
  'TU/pL',
  'vp/L',
  'vp/mL',
  'vp/uL',
  'vp/nL',
  'vp/pL',
  'IFU/L',
  'IFU/mL',
  'IFU/uL',
  'IFU/nL',
  'IFU/pL',
  'Capsids/mL',
  'LP/mL',
  'beads/L',
  'beads/mL',
  'beads/uL',
  'beads/nL',
  'beads/pL',
  'particles/L',
  'particles/mL',
  'particles/uL',
  'particles/nL',
  'particles/pL',
  'molecules/L',
  'molecules/mL',
  'molecules/uL',
  'molecules/nL',
  'molecules/pL',
  'OD/L',
  'OD/mL',
  'OD/uL',
  'OD/nL',
  'OD/pL',
  'GC/L',
  'GC/mL',
  'GC/uL',
  'GC/nL',
  'GC/pL',
  'mol/L',
  'mol/mL',
  'mol/uL',
  'mol/nL',
  'mol/pL',
  'mmol/L',
  'mmol/mL',
  'mmol/uL',
  'mmol/nL',
  'mmol/pL',
  'umol/L',
  'umol/mL',
  'umol/uL',
  'umol/nL',
  'umol/pL',
  'nmol/L',
  'nmol/mL',
  'nmol/uL',
  'nmol/nL',
  'nmol/pL',
  'pmol/L',
  'pmol/mL',
  'pmol/uL',
  'pmol/nL',
  'pmol/pL',
];

export const VALID_VOLUME_UNITS = ['None', 'L', 'mL', 'uL', 'nL', 'pL', 'gal (US)', 'qt (US)', 'pt (US)'];
export const VALID_CONTAINER_QUANITY_UNITS = [
  'None',
  'L',
  'mL',
  'uL',
  'nL',
  'pL',
  'gal (US)',
  'qt (US)',
  'pt (US)',
  'kg',
  'g',
  'mg',
  'ug',
  'ng',
  'pg',
  'lb',
  'oz',
  'mol',
  'mmol',
  'umol',
  'nmol',
  'pmol',
  'cells',
  '(x10^3) cells',
  '(x10^4) cells',
  '(x10^5) cells',
  '(x10^6) cells',
  '(x10^7) cells',
  '(x10^8) cells',
  '(x10^9) cells',
  'items',
  'units',
  'beads',
];
